import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "border-t border-neutral-800" }
const _hoisted_3 = { class: "container-default !px-0 grid grid-cols-2 lg:grid-cols-7 lg:divide-x divide-neutral-800" }
const _hoisted_4 = { class: "flex flex-col space-y-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "block text-neutral-400 text-sm mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Receive the most up-to date information on the development of Dripversity ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Non integer vulputate ut tempus mollis in blandit. Vestibulum, ultrices quis vitae sagittis et pellentesque. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, "Join our Discord", -1)
const _hoisted_10 = { class: "py-4 border-t border-b-[1rem] border-b-blue border-t-neutral-900" }
const _hoisted_11 = { class: "container-default flex flex-col md:flex-row items-start md:items-center justify-between md:space-x-8 lg:space-x-12" }
const _hoisted_12 = { class: "text-xs" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Made by "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link-2",
    href: "https://www.decentum.co/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Decentum")
], -1)
const _hoisted_14 = { class: "flex items-center justify-end space-x-4" }

import { routes } from "@/constants/";
import AppButton from "@/components/app/AppButton.vue";
import DiscordIcon from "@/components/icons/DiscordIcon.vue";
import FooterGridItem from "@/layouts/default/Footer/FooterGridItem.vue";
import NewsletterForm from "@/components/newsletter/NewsletterForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FooterGridItem, {
          title: "Home",
          routes: _unref(routes).home,
          class: "border-r border-b border-neutral-800 lg:border-b-0 lg:border-r-0"
        }, null, 8, ["routes"]),
        _createVNode(FooterGridItem, {
          title: "Help",
          routes: _unref(routes).support,
          class: "border-b border-neutral-800 lg:border-b-0"
        }, null, 8, ["routes"]),
        _createVNode(FooterGridItem, {
          title: "Social",
          class: "border-b border-neutral-800 lg:border-b-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).socials, (social, name) => {
                return (_openBlock(), _createElementBlock("li", { key: name }, [
                  _createElementVNode("a", {
                    href: social.baseUrl + '/' + social.account,
                    target: "_blank",
                    class: "inline-flex items-center space-x-2 link-2 font-normal",
                    rel: "noopener noreferrer"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(social.icon), { class: "block w-4 h-4" })),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(social.account), 1)
                  ], 8, _hoisted_5)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(FooterGridItem, {
          title: "Stay up to Date",
          size: "lg",
          class: "border-b border-neutral-800 lg:border-b-0"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(NewsletterForm)
          ]),
          _: 1
        }),
        _createVNode(FooterGridItem, {
          title: "Join the Community",
          size: "lg",
          class: "border-b border-neutral-800 lg:border-b-0"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(AppButton, {
              color: "outline",
              size: "sm",
              href: 
                            _unref(routes).socials.Discord.baseUrl +
                            '/' +
                            _unref(routes).socials.Discord.account
                        
            }, {
              default: _withCtx(() => [
                _createVNode(DiscordIcon, { class: "block w-4 h-4" }),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", null, " Copyright © " + _toDisplayString(new Date().getFullYear()) + " Dripversity ", 1),
            _hoisted_13
          ]),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).legals, (to, name) => {
              return (_openBlock(), _createElementBlock("li", { key: name }, [
                _createVNode(_component_router_link, {
                  class: "link text-xs",
                  to: to
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})